import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 5BEF006A-53C0-4401-87DB-F21642667712
 * name file-certificate
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-certificate.svg
 * tags
 * - Files / Folders 
 */
export const FileCertificateIcon = createSvgIcon(<><path d="M14 2H7A2 2 0 0 0 5 4V18A2 2 0 0 0 7 20H10V23L12 22L14 23V20H17A2 2 0 0 0 19 18V7M14 15V17L12 16L10 17V15L8 14L10 13V11L12 12L14 11V13L16 14M13 8V3.5L17.5 8Z" /></>, 'FileCertificateIcon');
export default FileCertificateIcon